import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconBolt = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Bolt'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 24 24' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d="M24.7501 -1H23.7501V0H24.7501V-1ZM15.7251 12L10.5501 18.2L11.3001 13H7.82506L12.4501 6.32501L11.7251 12H15.7251ZM5.90006 15H9.00006L8.20006 20.525C8.16673 20.8083 8.22106 21.0707 8.36306 21.312C8.5044 21.554 8.70006 21.7333 8.95006 21.85C9.20006 21.9667 9.4584 21.9917 9.72506 21.925C9.99173 21.8583 10.2167 21.7167 10.4001 21.5L18.6251 11.65C18.9084 11.3167 18.9627 10.9583 18.7881 10.575C18.6127 10.1917 18.3084 10 17.8751 10H14.0001L14.8001 3.52501C14.8334 3.24168 14.7834 2.97501 14.6501 2.72501C14.5167 2.47501 14.3084 2.30001 14.0251 2.20001C13.7417 2.10001 13.4667 2.09568 13.2001 2.18701C12.9334 2.27901 12.7167 2.44168 12.5501 2.67501L5.07506 13.425C4.84173 13.7583 4.82106 14.104 5.01306 14.462C5.2044 14.8207 5.50006 15 5.90006 15Z"
      />
    </Icon>
  )
}

IconBolt.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconBolt
